// ecomm.ski: create the custom product record before Dawn's product-form adds the line to the cart.
// Same contract as the live theme: POST https://admin.ecomm.ski/api/custom-products {shopify_product_id, shopify_variant_id}
// -> data.id is sent as line property _ecomm_ski_product_id.
// Works with Dawn's own <product-form>: this handler runs first (capture), then re-submits the form.
(function () {
  if (window.__agEcommskiProductForm) return;
  window.__agEcommskiProductForm = true;

  const API = 'https://admin.ecomm.ski/api/custom-products';

  function showError(form, message) {
    const wrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    const text = wrapper?.querySelector('.product-form__error-message');
    if (!wrapper || !text) return;
    text.textContent = message;
    wrapper.removeAttribute('hidden');
  }

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || form.dataset.type !== 'add-to-cart-form') return;
      // NOTE: live theme created an ecomm.ski record for every product form, not only with-form tags. Kept identical.

      if (form.dataset.agEcommskiReady === '1') {
        form.dataset.agEcommskiReady = '0';
        return; // second pass: let Dawn's product-form handle it
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      const submitter = event.submitter || form.querySelector('[type="submit"]');
      if (submitter && submitter.getAttribute('aria-disabled') === 'true') return;
      submitter?.setAttribute('aria-disabled', 'true');
      submitter?.classList.add('loading');

      try {
        const formData = new FormData(form);
        const response = await fetch(API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            shopify_product_id: formData.get('product-id'),
            shopify_variant_id: formData.get('id'),
          }),
        });
        const json = await response.json();
        const id = json && json.data && json.data.id;
        if (!response.ok || !id) throw new Error('ecomm.ski: no record id');

        let input = form.querySelector('input[name="properties[_ecomm_ski_product_id]"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[_ecomm_ski_product_id]';
          form.appendChild(input);
        }
        input.value = id;

        submitter?.removeAttribute('aria-disabled');
        submitter?.classList.remove('loading');
        form.dataset.agEcommskiReady = '1';
        form.requestSubmit(submitter || undefined);
      } catch (error) {
        console.error(error);
        submitter?.removeAttribute('aria-disabled');
        submitter?.classList.remove('loading');
        showError(form, 'Došlo je do greške, molimo pokušajte ponovo.');
      }
    },
    true
  );
})();
